import React from 'react';

const CardHeaderActions = ({ children }) => {
  return (
    <div className="w-full md:w-auto flex gap-x-4 items-center">{children}</div>
  );
};

export default CardHeaderActions;
